import { Container, Grid2, Link, Typography } from '@mui/material'
import Button from 'components/Button'
import { dashboardPath, myVaultPath, tradePath } from 'components/Routes'
import GoldieLogo from 'components/icons/GoldieLogo/GoldieLogo'
import useProducts from 'hooks/useProducts'
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom'
import useStyles from './styles'
import { formatWeightAsGrams } from 'utils/formatWeightAsGrams'

export default function BuyCelebration(): JSX.Element {
  const { classes } = useStyles()
  const navigate = useNavigate()
  const location = useLocation()

  const { state } = location
  const { weight } = state ?? {}
  const { productId, product } = useProducts()

  const handleClickViewAsset = () => {
    navigate(
      tradePath({
        routeParams: {
          productId
        }
      })
    )
  }

  const handleClickMyVault = () => {
    navigate(myVaultPath())
  }

  return (
    <Grid2 className={classes.wrapper} container justifyContent='center'>
      <Container maxWidth='sm' disableGutters>
        <Grid2 container p={2} gap={4}>
          <Grid2 size={{ xs: 12 }} className={classes.logoWrapper}>
            <Link
              color='textPrimary'
              component={RouterLink}
              to={dashboardPath()}
              className={classes.logo}
            >
              <GoldieLogo width='120px' />
            </Link>
          </Grid2>

          <Grid2 size={{ xs: 12 }}>
            <Typography className={classes.text}>
              {formatWeightAsGrams(weight * 1000)}.
            </Typography>
            <Typography className={classes.text}>Beautiful.</Typography>
          </Grid2>

          <Grid2 size={{ xs: 12 }}>
            <Typography className={classes.text}>
              You've officially invested {product?.name}.
            </Typography>
          </Grid2>

          <Grid2 size={{ xs: 12 }}>
            <Typography className={classes.text}>
              It's sitting securely right now in Wellington.
            </Typography>
          </Grid2>

          <Grid2 size={{ xs: 12 }} container gap={2} mt={4}>
            <Button className={classes.button} onClick={handleClickViewAsset}>
              View ASSET
            </Button>
            <Button className={classes.button} onClick={handleClickMyVault}>
              Go to MY VAULT
            </Button>
          </Grid2>
        </Grid2>
      </Container>
    </Grid2>
  )
}
